module.exports = __webpack_public_path__ + "img/arrow-square-up-right.39c6e6a9.svg";